<template>
  <div v-show="group1.isDocumentLinkShown && isShow" class="document-link" :class="{ 'is-sp': group1.page_type === 'sp' }">
    <a
      class="document-link-button"
      href="/lc/app/document-top/" 
      target="_blank"
    >
      <span class="document-link-text">資料検索</span>
      <IcSeparate class="icn"/>
    </a>
    <span class="document-link-popup">
      先例、通知、判例等を検索できます。
    </span>
  </div>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from 'vue'
// import { judgePageType } from '@/util/common'
import store from '@/store'
import * as common from '@/util/common'

export default defineComponent({
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      // ページタイプ(pc / sp / public)の判定
      group1.page_type = common.judgePageType()
    })

    const group1 = reactive({
      page_type: '',
      // 資料検索ボタンの表示条件
      isDocumentLinkShown: computed(() => {
        // 現在の画面名(/router/index.jsのrouter.beforeEach()メソッド内でストアに保存された値)
        const toName = store.state.common.toName

        let isShown
        if (toName === 'PCQADetailPreview') {
          // 書籍プレビューの場合は表示しない
          isShown = false
        } else {
          // その他の場合
          // 書籍リビジョンIDが存在する場合は表示する
          isShown = store.state.profile.book_revision_id.length > 0
        }

        return isShown
      })
    })

    // const background = reactive({
    //   image: computed(() => {
    //     let image = null
    //     if (group1.page_type === 'pc' || group1.page_type === 'sp') {
    //       // PCページ、SPページの場合は設定している背景画像を表示
    //       const template = store.state.profile.template
    //       image = common.getTemplateImage(template)
    //     } else {
    //       // publicの場合はデフォルトの背景画像を表示
    //       image = common.getPublicTemplateImage()
    //     }
    //     return image
    //   })
    // })

    return {
      group1
      // background
    }
  }
})
</script>

<style lang="scss" scoped>
  .document-link {
    @media print {
      display: none;
    }
    position: fixed;
    right: 60px;
    bottom: 20px;
    z-index: 100;
    &.is-sp {
      right: 20px;
      bottom: 102px;
    }
    .is-visible-menu & {
      visibility: hidden;
    }
    &-button {
      display: block;
      background-color: #fff;
      border-radius: 5px;
      border: 3px solid #005BAC;
      padding: 23px 48px;
      text-align: center;
      color: #005BAC;
      &:hover {
        & + .document-link-popup {
          visibility: visible;
          opacity: 1;
        }
      }
    }
    &-text {
      margin-right: 8px;
    }
    &-popup {
      min-width: 230px;
      padding: 17px 42px 21px 30px;
      background-color: #005BAC;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      line-height: 1.214;
      position: absolute;
      top: -14px;
      left: 50%;
      transform: translate(-50%, -100%);
      visibility: hidden;
      opacity: 0;
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 23px 6.5px 0 6.5px;
        border-color: #005BAC transparent transparent transparent;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transform: translateY(100%);
      }
    }
  }
</style>
